module.exports = __webpack_public_path__ + "static/img/6601_phase_function_Paper_Points.e57fd38.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/6601_phase_function_Paper_Points.png
// module id = bJMR
// module chunks = 0